module.exports = __webpack_public_path__ + "img/1fd64733b07f4df6a6add15983af72de.830c6986.jpg";